import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import React from 'react';

import logoUrl from '../../images/logo/aloha50__glyph@2x.png';
import appleTouchIcon57x57Url from '../../images/favicons/apple-touch-icon-57x57.png';
import appleTouchIcon114x114Url from '../../images/favicons/apple-touch-icon-114x114.png';
import appleTouchIcon72x72Url from '../../images/favicons/apple-touch-icon-72x72.png';
import appleTouchIcon144x144Url from '../../images/favicons/apple-touch-icon-144x144.png';
import appleTouchIcon60x60Url from '../../images/favicons/apple-touch-icon-60x60.png';
import appleTouchIcon120x120Url from '../../images/favicons/apple-touch-icon-120x120.png';
import appleTouchIcon76x76Url from '../../images/favicons/apple-touch-icon-76x76.png';
import appleTouchIcon152x152Url from '../../images/favicons/apple-touch-icon-152x152.png';
import favicon196x196 from '../../images/favicons/favicon-196x196.png';
import favicon96x96 from '../../images/favicons/favicon-96x96.png';
import favicon32x32 from '../../images/favicons/favicon-32x32.png';
import favicon16x16 from '../../images/favicons/favicon-16x16.png';
import favicon128 from '../../images/favicons/favicon-128.png';
import mstile144x144 from '../../images/favicons/mstile-144x144.png';
import mstile70x70 from '../../images/favicons/mstile-70x70.png';
import mstile150x150 from '../../images/favicons/mstile-150x150.png';
import mstile310x150 from '../../images/favicons/mstile-310x150.png';
import mstile310x310 from '../../images/favicons/mstile-310x310.png';

class Header extends React.Component {
  render() {
    let baseUrl = this.context.global.site.baseUrl;

    const meta = {
      title: 'Aloha50',
      appleTouchIcon57x57Url: `${baseUrl}${appleTouchIcon57x57Url}`,
      appleTouchIcon114x114Url: `${baseUrl}${appleTouchIcon114x114Url}`,
      appleTouchIcon72x72Url: `${baseUrl}${appleTouchIcon72x72Url}`,
      appleTouchIcon144x144Url: `${baseUrl}${appleTouchIcon144x144Url}`,
      appleTouchIcon60x60Url: `${baseUrl}${appleTouchIcon60x60Url}`,
      appleTouchIcon120x120Url: `${baseUrl}${appleTouchIcon120x120Url}`,
      appleTouchIcon76x76Url: `${baseUrl}${appleTouchIcon76x76Url}`,
      appleTouchIcon152x152Url: `${baseUrl}${appleTouchIcon152x152Url}`,
      favicon196x196: `${baseUrl}${favicon196x196}`,
      favicon96x96: `${baseUrl}${favicon96x96}`,
      favicon32x32: `${baseUrl}${favicon32x32}`,
      favicon16x16: `${baseUrl}${favicon16x16}`,
      favicon128: `${baseUrl}${favicon128}`,
      mstile144x144: `${baseUrl}/${mstile144x144}`,
      mstile70x70: `${baseUrl}/${mstile70x70}`,
      mstile150x150: `${baseUrl}/${mstile150x150}`,
      mstile310x150: `${baseUrl}/${mstile310x150}`,
      mstile310x310: `${baseUrl}/${mstile310x310}`,
      description: 'Aloha50 brings people together over common concerns and stories that are expressed through art.',
      shareImageUrl: `${baseUrl}${logoUrl}`
    };

    return (
      <Helmet>
        <title>{meta.title}</title>
        <link rel="icon" type="image/png" href={meta.iconUrl} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:image" content={meta.shareImageUrl} />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary" />
        <link rel="apple-touch-icon-precomposed" sizes="57x57" href={meta.appleTouchIcon57x57Url} />
        <link rel="apple-touch-icon-precomposed" sizes="114x114" href={meta.appleTouchIcon114x114Url} />
        <link rel="apple-touch-icon-precomposed" sizes="72x72" href={meta.appleTouchIcon72x72Url} />
        <link rel="apple-touch-icon-precomposed" sizes="144x144" href={meta.appleTouchIcon144x144Url} />
        <link rel="apple-touch-icon-precomposed" sizes="60x60" href={meta.appleTouchIcon60x60Url} />
        <link rel="apple-touch-icon-precomposed" sizes="120x120" href={meta.appleTouchIcon120x120Url} />
        <link rel="apple-touch-icon-precomposed" sizes="76x76" href={meta.appleTouchIcon76x76Url} />
        <link rel="apple-touch-icon-precomposed" sizes="152x152" href={meta.appleTouchIcon152x152Url} />
        <link rel="icon" type="image/png" href={meta.favicon196x196} sizes="196x196" />
        <link rel="icon" type="image/png" href={meta.favicon96x96} sizes="96x96" />
        <link rel="icon" type="image/png" href={meta.favicon32x32} sizes="32x32" />
        <link rel="icon" type="image/png" href={meta.favicon16x16} sizes="16x16" />
        <link rel="icon" type="image/png" href={meta.favicon128} sizes="128x128" />
        <meta name="msapplication-TileColor" content="#FFFFFF" />
        <meta name="msapplication-TileImage" content={meta.mstile144x144} />
        <meta name="msapplication-square70x70logo" content={meta.mstile70x70} />
        <meta name="msapplication-square150x150logo" content={meta.mstile150x150} />
        <meta name="msapplication-wide310x150logo" content={meta.mstile310x150} />
        <meta name="msapplication-square310x310logo" content={meta.mstile310x310} />
      </Helmet>
    );
  }
}

Header.contextTypes = {
  global: PropTypes.shape({
    site: PropTypes.shape({
      baseUrl: PropTypes.string.isRequired
    })
  })
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.jsx